import { Platform } from 'react-native'

export const isMobile = () => Platform.OS !== 'web'

export const isIOS = () => Platform.OS === 'ios'

export const isAndroid = () => Platform.OS === 'android'

export const isWeb = () => Platform.OS === 'web'

export function meetsMinimumVersion(versionNumber: number) {
  return +Platform.Version >= versionNumber
}

export const supportsIOSVersion = (version: number) => isIOS() && meetsMinimumVersion(version)
